var React = require('react');

function SmallArrow (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st0{fill:#DB4140;}\n"),React.createElement("path",{"id":"iconmonstr-arrow-20_4_","className":"st0","d":"M16.1,0L14,2l4.5,4.5H0v2.9h18.5L14,13.9l2.1,2L24,8L16.1,0z","key":1})]);
}

SmallArrow.defaultProps = {"version":"1.0","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 24 15.9","style":{"enableBackground":"new 0 0 24 15.9"},"xmlSpace":"preserve"};

module.exports = SmallArrow;

SmallArrow.default = SmallArrow;
